import clsx from 'clsx'

import type { NavTabsItemProps } from './types'

const NavTabsItem = ({
  children,
  disabled,
  active,
  slot,
  className,
  'data-test': dataTest
}: NavTabsItemProps) => {
  const classes = clsx(
    {
      'hot-nav__item--disabled': disabled,
      'hot-nav__item--active': active
    },
    className
  )

  return (
    <hot-nav-item
      slot={slot}
      class={classes}
      data-test={dataTest}
      data-item-active={active}
      data-item-disabled={disabled}>
      {children}
    </hot-nav-item>
  )
}

export default NavTabsItem
